// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Id} from './id.js'

export class TransientInteractionEnded {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): TransientInteractionEnded {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsTransientInteractionEnded(
    bb: flatbuffers.ByteBuffer,
    obj?: TransientInteractionEnded
  ): TransientInteractionEnded {
    return (obj || new TransientInteractionEnded()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsTransientInteractionEnded(
    bb: flatbuffers.ByteBuffer,
    obj?: TransientInteractionEnded
  ): TransientInteractionEnded {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new TransientInteractionEnded()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  interactionId(obj?: Id): Id | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new Id()).__init(this.bb_pos + offset, this.bb!) : null
  }

  replacedByOp(obj?: Id): Id | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? (obj || new Id()).__init(this.bb_pos + offset, this.bb!) : null
  }

  static startTransientInteractionEnded(builder: flatbuffers.Builder) {
    builder.startObject(2)
  }

  static addInteractionId(builder: flatbuffers.Builder, interactionIdOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, interactionIdOffset, 0)
  }

  static addReplacedByOp(builder: flatbuffers.Builder, replacedByOpOffset: flatbuffers.Offset) {
    builder.addFieldStruct(1, replacedByOpOffset, 0)
  }

  static endTransientInteractionEnded(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // interaction_id
    return offset
  }
}
